'use strict';
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lmealorama_jsonCodecs$package$$anon$143(ps$84) {
  this.a6R = null;
  this.a6R = ps$84;
}
export { $c_Lmealorama_jsonCodecs$package$$anon$143 as $c_Lmealorama_jsonCodecs$package$$anon$143 };
$p = $c_Lmealorama_jsonCodecs$package$$anon$143.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lmealorama_jsonCodecs$package$$anon$143;
/** @constructor */
function $h_Lmealorama_jsonCodecs$package$$anon$143() {
}
export { $h_Lmealorama_jsonCodecs$package$$anon$143 as $h_Lmealorama_jsonCodecs$package$$anon$143 };
$h_Lmealorama_jsonCodecs$package$$anon$143.prototype = $p;
$p.v = (function() {
  return new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_Product$$anon$1(this);
});
$p.r = (function() {
  return "";
});
$p.q = (function() {
  return this.a6R.a.length;
});
$p.g = (function(i) {
  return this.a6R.a[i];
});
var $d_Lmealorama_jsonCodecs$package$$anon$143 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lmealorama_jsonCodecs$package$$anon$143, "mealorama.jsonCodecs$package$$anon$143", ({
  IU: 1,
  b: 1,
  c: 1
}));
export { $d_Lmealorama_jsonCodecs$package$$anon$143 as $d_Lmealorama_jsonCodecs$package$$anon$143 };
//# sourceMappingURL=mealorama.json-Codecs$package$$anon$143.js.map
